import { Formik, Form } from "formik";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { Icon } from "@mui/material";

import { useMutation } from "@tanstack/react-query";
import MDTypography from "components/MDTypography";
import { useState } from "react";

import { uploadLocation } from "services/data.internal.service";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { InboundHeaderCard } from "ui-components/Layout";
import { InboundLayout } from "ui-components/Layout";
import { Success, Error, LoadingDialog } from "ui-components/Alert";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { useCustomerValue } from "providers/CustomerContext";

function UploadLocation() {
  const {customerCode} = useCustomerValue()
  const [alert, setAlert] = useState(null);
  const [uploadResps, setUploadResps] = useState([]);
  const uploadLocationMutation = useMutation(uploadLocation, {});
  const uploadStatus = uploadLocationMutation.status === "loading";
  const {isDownloading, downloadCsv} = useCsvDownloadHook();

  const handleSubmit = (values, actions) => {
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);

    uploadLocationMutation.mutate(formData, {
      onSuccess: (data) => {
        document.getElementById("files").value = null;
        setUploadResps(data.data.data);
      },
      onError: (data) => {
        console.log(data)
        setAlert(<Error data={data} onChange={setAlert} />);
      },
    });
    actions.setSubmitting(false);
  };

  const handleDownload = () => {
    window.open("/api/template/gettemplate?type=location");
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {isDownloading && <ExportDialog />}
      {uploadStatus && <LoadingDialog />}
      <InboundHeaderCard>
        <MDBox>
          <MDTypography color="info" variant="h3">
            Upload Location
          </MDTypography>
          <MDButton variant="gradient" color="info" onClick={handleDownload}>
            Download Template
          </MDButton>
          <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
            {({ values, isSubmitting, setFieldValue }) => (
              <Form>
                <MDBox mt={2}>
                  <input
                    type="file"
                    name="files"
                    id="files"
                    onChange={(e) => {
                      setUploadResps([]);
                      setFieldValue("files", e.target.files);
                    }}
                  />
                </MDBox>

                <MDBox mt={2} display="flex" justifyContent="center">
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    disabled={!values.files.length > 0 || isSubmitting}
                  >
                    {isSubmitting ? "Uploading" : "Upload"}
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </InboundHeaderCard>

      {uploadResps.length > 0 && (
        <InboundHeaderCard>
          <MDTypography sx={{ marginBottom: ".5rem" }} color="info" variant="h4">
            Upload Response{" "}
            {/* <MDButton type="submit" variant="gradient" color="info">
              <Icon>download</Icon>&nbsp;
              <CSVLink
                style={{ color: "white" }}
                headers={[
                  {
                    label: "Warehouse Code",
                    key: "warehouseCode",
                  },
                  {
                    label: "Zone Id",
                    key: "zoneID",
                  },
                  {
                    label: "Location Id",
                    key: "locationID",
                  },
                  {
                    label: "Message",
                    key: "message",
                  },
                ]}
                filename={"upload_location_" + dayjs(new Date()).format("DD-MM-YYYY")}
                data={uploadResps.filter((x) => !x.success)}
              >
                Export
              </CSVLink>
            </MDButton> */}
            <MDButton
              type="submit" variant="gradient" color="info"
              onClick={() => {
                const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_UploadLocation`;
                const headers = [
                  {
                    label: "Warehouse Code",
                    key: "warehouseCode",
                  },
                  {
                    label: "Zone Id",
                    key: "zoneID",
                  },
                  {
                    label: "Location Id",
                    key: "locationID",
                  },
                  {
                    label: "Message",
                    key: "message",
                  },
                ]
                downloadCsv(filename, uploadResps.filter((x) => !x.success), headers)
              }}
            >
              <Icon>download</Icon>&nbsp;
              export
            </MDButton>
          </MDTypography>
          <StripedDataGrid
            columns={[
              {
                headerName: "Status",
                field: "success",
                align: "center",
                renderCell: (cell) =>
                  cell.row.success ? (
                    <StatusIcon color="success" icon="done" />
                  ) : (
                    <StatusIcon color="error" icon="close" />
                  ),
              },
              { headerName: "Warehouse Code", field: "warehouseCode", width: 200 },
              { headerName: "Zone Id", field: "zoneID", width: 200 },
              { headerName: "Location Id", field: "locationID", width: 200 },

              {
                headerName: "Message",
                field: "message",
                flex: 1,
                renderCell: (cell) => (
                  <div>
                    {cell.row.message.map((c, i) => (
                      <p key={i}>{c}</p>
                    ))}
                  </div>
                ),
              },
            ]}
            rows={uploadResps}
            getRowHeight={(cell) => {
              if (cell.model.message.length > 2) {
                return "auto";
              } else {
                return 50;
              }
            }}
          />
        </InboundHeaderCard>
      )}
    </InboundLayout>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default UploadLocation;
